import { Injectable } from '@angular/core';
import { RequestOptions, Headers, Http } from '@angular/http';
import { EnvironmentConfiguration } from 'app/environment/services/environment.configuration';
import { AppAuthHttpService } from 'app/http/app.auth.http.service';
import { ResponseUtilService } from 'app/shared/utils/response-util.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class GuidGeneratorService {

  private generateGuidUrl: string =
    this.environment.baseUrl + '/api/guid/generate/';

  constructor(
    private http: AppAuthHttpService,
    private environment: EnvironmentConfiguration,
    private responseUtilService: ResponseUtilService
  ) {}

  private get jsonOptions(): RequestOptions {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return options;
  }

  generateGuid(recordType: string): Observable<any> {
    return this.http
      .get(
        this.generateGuidUrl + recordType
      )
      .map((response) => response.json())
      .catch((response) => this.responseUtilService.handleError(response))
      .share();
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/guid-generator.service.ts